import { render, staticRenderFns } from "./SetupStep5.vue?vue&type=template&id=f420b28c&"
import script from "./SetupStep5.vue?vue&type=script&lang=ts&"
export * from "./SetupStep5.vue?vue&type=script&lang=ts&"
import style0 from "./SetupStep5.vue?vue&type=style&index=0&id=f420b28c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports